import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'

import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    DeploymentRequestResponse,
} from 'app/requests/Deployment/Deployment.types'

const config: SkyNetTableConfig<keyof DeploymentRequestResponse> = {
    name: 'DeploymentsTable',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'deploymentName',
                reduced: true,
                minWidth: '300px',
                labelKey: 'DEPLOYMENT_NAME',
            },
            {
                name: 'createdOn',
                width: '300px',
                componentName: 'DateTimeCell',
                labelKey: 'CREATED_ON',
            },
            {
                name: 'createdBy',
                width: '300px',
                labelKey: 'CREATED_BY',
            },
        ],
    }],
}

export default config
